import axios, { AxiosError } from "axios";
import { http } from '../http';

export interface Regional {
  codigo_regional: string;
  nome: string;
  nome_fantasia: string;
  cnpj: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  estado: string;
  cep: string;
  email: string;
  website: string;
  telefone: string;
  situacao: string;
}

export interface Cota {
  codigo_cota: string;
  cota: number;
  descricao_cota: string;
  valor_cota: string | null;
  valor_fipe_inicial: number;
  valor_fipe_final: number;
  valor_adesao: number | null;
  participacao_minima: number | null;
  porcentagem_fipe: number | null;
  formato_cobranca: string | null;
  descricao_tipo_veiculo: string | null;
  regionais: Regional[];
}

export type CotaResponse = Cota;

export interface CotaSyncExecucao {
  id: string;
  status: 'EM_ANDAMENTO' | 'CONCLUIDO' | 'FALHA' | 'INTERROMPIDO';
  origem: 'CRON' | 'MANUAL';
  fase: 'COTAS' | 'VINCULOS';
  total: number;
  consultadas: number;
  percentual: number;
  atualizadas: number;
  criadasSemVinculo: number;
  inativadas: number;
  vinculosReconstruidos: number;
  vinculosPendentes: number;
  falhas: number;
  erro: string | null;
  iniciadoEm: string;
  finalizadoEm: string | null;
}

export interface CotaSyncStatus {
  totalCotas: number;
  cotasAtivas: number;
  cotasInativas: number;
  ultimaSincronizacao: string | null;
  execucao: CotaSyncExecucao | null;
}

export const getCotaSyncStatus = async (): Promise<CotaSyncStatus> => {
  try {
    const response = await http.get<CotaSyncStatus>('/sga-cota/sync-status');
    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao consultar status do sync de cotas');
    }
    throw new Error('Erro desconhecido');
  }
};

export const dispararSyncCotas = async (): Promise<{ mensagem: string }> => {
  try {
    const response = await http.post<{ mensagem: string }>('/sga-cota/sync-automatico', undefined);
    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao disparar sincronização de cotas');
    }
    throw new Error('Erro desconhecido');
  }
};

export const fetchSgaCotas = async (
  codigoRegional: string,
  codigoCooperativa: string,
  codigoTipoVeiculo: string,
  valorFipe: string
): Promise<Cota[]> => {
  const url = `/sga-cota/buscar/${codigoRegional}/${codigoCooperativa}/${codigoTipoVeiculo}/${valorFipe}`;

  try {
    const response = await http.get<Cota[]>(url);

    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError;
    throw axiosError;
  }
};
